import 'css-chunksrc/client/pages/zonePage/reportsPage/toolbar/sort/styles.scss';export default {
  "sortDropdown": "_sortDropdown_hmd84_1",
  "title": "_title_hmd84_10",
  "root": "_root_hmd84_16",
  "input": "_input_hmd84_20",
  "opened": "_opened_hmd84_38",
  "icon": "_icon_hmd84_43",
  "listRoot": "_listRoot_hmd84_57",
  "list": "_list_hmd84_57",
  "option": "_option_hmd84_73",
  "selected": "_selected_hmd84_81"
};